export interface CMSSystemInfoReply {
  /** 域名是否配置 */
  domainIsConfig: boolean
  /** logo 图标 */
  logoIcon: string
  /** logo 缩略图 */
  logo: string
  /** logo 整体图片。 可能带上文字 比如：充电桩服务商 */
  logoEntire: string
  /** 公司名称 */
  companyName: string
  /** 公司简介 */
  companyIntro: string
  /** 公司地址 */
  companyAddress: string
  /** 公司官网链接 */
  companyUrl: string
  /** 登录页标题 */
  loginTitle: string
  /** 登录页背景图 */
  loginImage: string
  /** 服务时区 */
  srvTimeZone: string
  /** 服务器时区相对UTC偏移量 秒 */
  timeZoneOffset: number
  /** 是否在中国 */
  inChina: boolean
  /** IPC */
  ipcInfo: string
  /** IPC 链接地址 */
  ipcURL: string
  /** 账号类型列表, 只用显示哪些账号类型， */
  accountTypes: string[]
}

export interface HistoryRouter {
  fullPath: string
  name: string
}

export enum DefaultRoleType {
  /** DRT_ADMIN - 超级管理员 */
  DRT_ADMIN = 1,
  /** DRT_BRAND_OPERATOR - 品牌商 */
  DRT_BRAND_OPERATOR = 2,
  /** DRT_AGENT_OPERATOR - 代理商 */
  DRT_AGENT_OPERATOR = 3,
  /** DRT_STATION - 充电站 */
  DRT_STATION = 4,
  /** DRT_BRAND_OPERATOR_VIEW - 品牌商只读管理员 */
  DRT_BRAND_OPERATOR_VIEW = 5,
  /** DRT_AGENT_OPERATOR_VIEW - 代理商只读管理员 */
  DRT_AGENT_OPERATOR_VIEW = 6,
  /** DRT_STATION_VIEW - 充电站只读管理员 */
  DRT_STATION_VIEW = 7,
  /** DRT_OPS - 运维管理员 */
  DRT_OPS = 8,
  /** DRT_FINANCE - 财务管理员 */
  DRT_FINANCE = 9,
  /** DRT_PROFIT_SHARING_PAYEE - 收款方 */
  DRT_PROFIT_SHARING_PAYEE = 10,
}
